import { COMPONENT_STATES, COMPONENT_TYPE, DEFAULT_MEDIA_QUERY_PLATFORMS } from 'common/constants';
import { UNIFORM_PROPS } from 'common/constants/component-props';
import { defaultProps } from './constants';
import { createModel } from '../create-model';
import type { CreatedBuildingBlock } from '../creation-types';

export const answerInput = (): CreatedBuildingBlock<typeof COMPONENT_TYPE.ANSWER_INPUT> =>
	createModel({
		type: COMPONENT_TYPE.ANSWER_INPUT,
		componentProps: {
			[UNIFORM_PROPS.fieldPlaceholder]: '',
			[UNIFORM_PROPS.answerInputMode]: defaultProps.answerInputMode,
			styles: {
				[COMPONENT_STATES.DEFAULT]: {
					[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {},
					[DEFAULT_MEDIA_QUERY_PLATFORMS.DESKTOP]: {},
					[DEFAULT_MEDIA_QUERY_PLATFORMS.TABLET]: {},
					[DEFAULT_MEDIA_QUERY_PLATFORMS.MOBILE]: {},
				},
				[COMPONENT_STATES.HOVER]: {
					[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {},
				},
				[COMPONENT_STATES.CORRECT]: {
					[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {},
				},
				[COMPONENT_STATES.INCORRECT]: {
					[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {},
				},
			},
			other: {},
		},
		children: [],
	}) satisfies CreatedBuildingBlock<typeof COMPONENT_TYPE.ANSWER_INPUT>;
